/* Protect24 Club – Mitglieds-Freischaltung, Club-Rabatt und Weiterempfehlen.
   Gespeichert werden (nur im Browser des Mitglieds) ein signiertes Token, die
   persönlichen Einmal-Codes und die E-Mail-Adresse. Die E-Mail braucht das
   Empfehlungsportal, um den persönlichen Empfehlungslink anzuzeigen. */
(function () {
  'use strict';

  var STORAGE_KEY = 'p24Club';
  var script = document.currentScript;
  var endpoint = script && script.dataset.endpoint;
  var apiBase = endpoint ? endpoint.replace(/\/verify-member\/?$/, '') : '';
  var signupUrl = (script && script.dataset.signup) || 'https://vetprotect24.de/clubmitglied';
  var referralBase = (script && script.dataset.referral) || 'https://vetprotect24.de/empfehlungsportal';
  var referralFallback = (script && script.dataset.referralFallback) || 'https://vetprotect24.de/freunde-werben-freunde';

  function readState() {
    try {
      var data = JSON.parse(localStorage.getItem(STORAGE_KEY) || 'null');
      if (!data || !data.token || !data.until || data.until < Date.now()) return null;
      return data;
    } catch (e) {
      return null;
    }
  }

  function writeState(state) {
    try {
      if (state) localStorage.setItem(STORAGE_KEY, JSON.stringify(state));
      else localStorage.removeItem(STORAGE_KEY);
    } catch (e) {}
  }

  function post(path, body) {
    return fetch(apiBase + path, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(body),
    }).then(function (res) {
      return res.json().catch(function () { return {}; }).then(function (data) {
        return { status: res.status, ok: res.ok, data: data };
      });
    });
  }

  var CHECK_EVERY_MS = 15 * 60 * 1000;
  var RECHECK_AFTER_MS = 60 * 1000;
  var OUR_CODE = /^CLUB-(P\d+-)?[0-9A-F]{8,12}$/i;

  // Ein Mitglied hat mehrere Codes: einen für die 25 % und je einen für jedes
  // Produkt mit eigenem Clubpreis. Ältere Zustände kennen nur einen Code.
  function stateCodes(state) {
    if (state.codes && state.codes.length) return state.codes;
    return state.code ? [state.code] : [];
  }

  function codesNeedCheck(state) {
    if (!stateCodes(state).length || !state.maxPercent) return true;
    if (!state.codeExpiresAt || Date.parse(state.codeExpiresAt) - Date.now() < 10 * 60 * 1000) return true;
    return !state.checkedAt || Date.now() - state.checkedAt > CHECK_EVERY_MS;
  }

  function storeCodes(state, data) {
    state.codes = data.codes || (data.code ? [data.code] : []);
    state.code = data.code || state.codes[0] || null;
    state.codeExpiresAt = data.codeExpiresAt;
    state.checkedAt = Date.now();
    if (data.maxPercent) state.maxPercent = data.maxPercent;
    showMaxPercent(state);
  }

  // „bis zu … %" in der Hinweisleiste und unten links.
  function showMaxPercent(state) {
    if (!state || !state.maxPercent) return;
    Array.prototype.forEach.call(document.querySelectorAll('[data-club-max-percent]'), function (el) {
      el.textContent = state.maxPercent;
    });
  }

  // Der Server behält gültige Codes und ersetzt nur eingelöste oder ablaufende.
  function refreshCodes(state) {
    return post('/club-code', { token: state.token, codes: stateCodes(state) })
      .then(function (res) {
        if (res.ok && (res.data.codes || res.data.code)) {
          storeCodes(state, res.data);
          writeState(state);
          return state;
        }
        if (res.status === 401 || res.status === 403) {
          writeState(null);
          deactivate();
          return null;
        }
        return state;
      })
      .catch(function () { return state; });
  }

  function refreshCartUi() {
    if (/^\/cart\/?$/.test(location.pathname)) {
      location.reload();
      return;
    }
    var drawer = document.querySelector('cart-drawer');
    if (!drawer) return;
    fetch('/?sections=cart-drawer,cart-icon-bubble')
      .then(function (res) { return res.json(); })
      .then(function (sections) {
        var doc = new DOMParser().parseFromString(sections['cart-drawer'], 'text/html');
        var fresh = doc.querySelector('#CartDrawer');
        var current = document.querySelector('#CartDrawer');
        if (fresh && current) current.innerHTML = fresh.innerHTML;
        drawer.classList.toggle('is-empty', !!doc.querySelector('cart-drawer.is-empty'));
      })
      .catch(function () {});
  }

  function getCart() {
    return fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (res) {
      return res.json();
    });
  }

  function setCartCodes(codes) {
    return fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ discount: codes.join(',') }),
    }).then(getCart);
  }

  // Legt alle Club-Codes in den Warenkorb. Shopify rechnet je Artikel nur den
  // besten davon an. Codes, die der Kunde selbst eingegeben hat, bleiben stehen.
  function applyCodesToCart(state) {
    var wanted = stateCodes(state).map(function (c) { return String(c).toUpperCase(); });
    if (!wanted.length) return Promise.resolve(null);
    return getCart()
      .then(function (cart) {
        var present = (cart.discount_codes || []).map(function (d) { return String(d.code).toUpperCase(); });
        var missing = wanted.some(function (c) { return present.indexOf(c) === -1; });
        var stale = present.some(function (c) { return OUR_CODE.test(c) && wanted.indexOf(c) === -1; });
        if (!missing && !stale) return cart;
        var foreign = present.filter(function (c) { return !OUR_CODE.test(c); });
        return setCartCodes(wanted.concat(foreign)).then(function (updated) {
          if (updated.item_count > 0) refreshCartUi();
          return updated;
        });
      })
      .catch(function () { return null; });
  }

  // Greift ein Club-Code im Warenkorb nicht, kann er schon eingelöst sein –
  // oder er passt nur zu keinem Artikel (der 25-%-Code bei reinen Angeboten).
  // Das entscheidet der Server; höchstens einmal pro Minute nachfragen.
  function syncDiscount(state) {
    var ready = codesNeedCheck(state) ? refreshCodes(state) : Promise.resolve(state);
    return ready.then(function (current) {
      if (!current) return;
      return applyCodesToCart(current).then(function (cart) {
        if (!cart || !cart.item_count) return;
        var idle = (cart.discount_codes || []).some(function (d) { return OUR_CODE.test(d.code) && !d.applicable; });
        if (idle && Date.now() - (current.checkedAt || 0) > RECHECK_AFTER_MS) {
          return refreshCodes(current).then(function (next) {
            if (next) return applyCodesToCart(next);
          });
        }
      });
    });
  }

  // Jeder Link aufs Empfehlungsportal führt Mitglieder direkt in ihr eigenes
  // Konto. Gleiches Fenster, damit man in der App bleibt.
  function updateReferralLinks(state) {
    var url = state && state.email
      ? referralBase + '?email=' + encodeURIComponent(state.email)
      : referralFallback;
    var links = document.querySelectorAll('a[href^="' + referralBase + '"], a[data-club-referral]');
    Array.prototype.forEach.call(links, function (link) {
      link.setAttribute('data-club-referral', '');
      link.href = url;
      link.removeAttribute('target');
    });
  }

  function activate(state) {
    document.documentElement.classList.add('club-member');
    document.body.classList.add('vip-active');
    var opener = document.getElementById('ClubUnlock');
    if (opener) opener.hidden = true;
    updateReferralLinks(state);
    showMaxPercent(state);
  }

  function deactivate() {
    document.documentElement.classList.remove('club-member');
    document.body.classList.remove('vip-active');
  }

  function verifyEmail(email) {
    var previous = readState();
    var known = previous ? stateCodes(previous) : [];
    return post('/verify-member', { email: email, codes: known }).then(function (res) {
      if (res.status === 429) throw new Error('rate');
      if (!res.ok) throw new Error('server');
      if (!res.data.isMember) return null;
      var state = {
        email: email.toLowerCase(),
        tier: res.data.tier,
        token: res.data.token,
        until: Date.now() + 7 * 24 * 60 * 60 * 1000,
      };
      storeCodes(state, res.data);
      writeState(state);
      activate(state);
      return applyCodesToCart(state).then(function () { return state; });
    });
  }

  // Nach dem Hinzufügen zum Warenkorb sicherstellen, dass der Code greift.
  function watchCartAdds() {
    var originalFetch = window.fetch;
    window.fetch = function (input, init) {
      var url = typeof input === 'string' ? input : (input && input.url) || '';
      var result = originalFetch.apply(this, arguments);
      if (/\/cart\/add/.test(url)) {
        result.then(function () {
          var state = readState();
          if (state) setTimeout(function () { syncDiscount(state); }, 300);
        });
      }
      return result;
    };
  }

  function setupDialog() {
    var opener = document.getElementById('ClubUnlock');
    var dialog = document.getElementById('ClubUnlockDialog');
    if (!dialog) return;

    var form = dialog.querySelector('form');
    var input = dialog.querySelector('input[type="email"]');
    var submit = dialog.querySelector('.club-unlock__submit');
    var msg = dialog.querySelector('.club-unlock__msg');

    function open(event) {
      if (event) event.preventDefault();
      msg.textContent = '';
      if (typeof dialog.showModal === 'function') dialog.showModal();
      else dialog.setAttribute('open', '');
      input.focus();
    }

    function close() {
      if (typeof dialog.close === 'function') dialog.close();
      else dialog.removeAttribute('open');
    }

    function showMessage(text, linkLabel) {
      msg.textContent = text;
      if (linkLabel) {
        var a = document.createElement('a');
        a.href = signupUrl;
        a.textContent = linkLabel;
        msg.appendChild(document.createTextNode(' '));
        msg.appendChild(a);
      }
    }

    if (opener && !document.body.classList.contains('vip-active')) opener.hidden = false;
    if (opener) opener.querySelector('button').addEventListener('click', open);

    document.addEventListener('click', function (event) {
      if (event.target.closest('.card-club-price__guest')) open(event);
    });

    dialog.querySelector('.club-unlock__close').addEventListener('click', close);
    dialog.addEventListener('click', function (event) {
      if (event.target === dialog) close();
    });

    form.addEventListener('submit', function (event) {
      event.preventDefault();
      var email = input.value.trim();
      if (!email || !input.checkValidity()) {
        showMessage('Bitte gib eine gültige E-Mail-Adresse ein.');
        return;
      }
      submit.disabled = true;
      showMessage('Wird geprüft …');
      verifyEmail(email)
        .then(function (state) {
          if (state) {
            showMessage('Willkommen im Club! Deine Club-Preise sind jetzt aktiv.');
            setTimeout(close, 1500);
          } else {
            showMessage('Diese E-Mail-Adresse gehört zu keiner aktiven Club-Mitgliedschaft.', 'Jetzt Clubmitglied werden');
          }
        })
        .catch(function (err) {
          showMessage(
            err.message === 'rate'
              ? 'Zu viele Versuche. Bitte warte eine Minute.'
              : 'Die Prüfung ist gerade nicht erreichbar. Bitte versuche es später erneut.'
          );
        })
        .finally(function () {
          submit.disabled = false;
        });
    });
  }

  function emailFromUrl() {
    var params = new URLSearchParams(location.search);
    var email = params.get('email');
    if (!email) return null;
    params.delete('email');
    var rest = params.toString();
    history.replaceState(null, '', location.pathname + (rest ? '?' + rest : '') + location.hash);
    email = email.trim();
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email) ? email : null;
  }

  function init() {
    if (!apiBase) return;
    watchCartAdds();

    var urlEmail = emailFromUrl();
    var state = readState();

    if (state) {
      activate(state);
      syncDiscount(state);
    } else {
      deactivate();
    }
    setupDialog();

    // Neu prüfen, wenn die App eine andere (oder bisher keine gespeicherte)
    // E-Mail mitschickt – sonst führte „Weiterempfehlen" ins falsche Konto.
    if (urlEmail && (!state || state.email !== urlEmail.toLowerCase())) {
      verifyEmail(urlEmail).catch(function () {});
    }
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
